<template>
	<div>
		<!-- 两会专题 -->
		<NPCandCPPCC v-if="$route.query.chnid"></NPCandCPPCC>
		<div v-else class="container">
			<!-- 栏目 -->
			<div class="leftbar" v-if="windowWidth > 769">
				<ul class="viewbox">
					<p class="view">
						<span
							style="color: white"
							@click="
								firstEntryList(
									columnData.uid,
									$route.query.type
								)
							"
						>
							{{ columnData.text }}
						</span>
						<!-- WWWW 季刊 WWWW -->
						<a
							href="#"
							v-if="$route.query.uid == '24963'"
							style="color: white"
						>
							信息精选季刊
						</a>
						<!--MMMM 季刊 MMMM -->
					</p>
					<ul id="accordion" class="accordion">
						<li v-for="item in columnData.children" :key="item.uid">
							<template
								v-if="
									item.webchanneltypeid != '30' &&
									item.webchanneltypeid != '90' &&
									item.webchanneltypeid != '20' &&
									item.isnav
								"
							>
								<div class="link">
									<!-- <router-link
                  :to="{ path: '/list', query: { uid: item.uid, type: '1' } }"
                  class="linktxt"
                  > -->
									<span
										class="linktxt"
										@click="
											firstEntryList(
												item.uid,
												item.listType
											)
										"
										:style="{ color: selectedState }"
									>
										{{ item.text }}
									</span>
									<!-- </router-link> -->
									<span
										class="link_icon"
										v-if="item.children.length"
										@click="showChildList($event)"
									>
										<img
											:src="
												require('./images/arrow_right.png')
											"
										/>
									</span>
								</div>
								<div
									v-if="item.children.length"
									style="display: none"
								>
									<ListColumn
										:columnData="item"
										:columnLevelFilterData="
											columnLevelFilterData
										"
										:loadingArticle="firstEntryList"
									></ListColumn>
								</div>
							</template>
						</li>
						<!-- WWWW 季刊 WWWW -->
						<li v-if="$route.query.uid == '24963'">
							<div class="link">
								<span
									class="linktxt"
									style="color: #ac0002"
									@click="
										firstEntryList(item.uid, item.listType)
									"
								>
									信息精选季刊
								</span>
							</div>
						</li>
						<!--MMMM 季刊 MMMM -->
					</ul>
				</ul>
				<!-- 国情民生特殊处理 start-->
				<div
					class="special-column"
					style="margin: 0; padding: 0"
					v-if="
						$route.query.uid == 'A31024' &&
						cityFilterData.length > 0
					"
				>
					<div class="title_study">
						<a href="#" class="t_txt"
							><img
								src="./images/icon_title.png"
								class="special-column-icon"
							/>
							<span>{{ cityFilterData[0].name }}</span>
							<!-- {{ specialColumnData.text }} -->
						</a>
					</div>
					<div class="t_line">
						<img src="./images/icon_title_line.png" />
					</div>
					<ul class="accordion">
						<li
							v-for="(item, index) in cityFilterData[0].value"
							:key="index"
						>
							<div class="link overflow">
								<span
									@click="
										provinceFilterClick(
											$route.query.uid,
											1,
											item.value
										)
									"
									class="linktxt"
									:title="item.name"
									:style="{
										color:
											page.attr == item.name
												? '#ac0002'
												: '#333',
									}"
									>{{ item.name }}
								</span>
								<!-- <span
                  v-else
                  @click="specialColumnClick30(item.uid, item.listType, false)"
                  class="linktxt"
                  >{{ item.text }}
                </span>
                <span
                  class="link_icon"
                  v-if="item.children.length"
                  @click="showChildList($event, item.uid)"
                >
                  <img :src="require('./images/arrow_right.png')" />
                </span> -->
							</div>
							<!-- <div
                v-if="item.children.length"
                style="display: none"
                class="spaceShow"
              >
                <ListColumn
                  :columnData="item"
                  :columnLevelFilterData="columnLevelFilterData"
                  :loadingArticle="firstEntryList"
                ></ListColumn>
              </div> -->
						</li>
					</ul>
				</div>
				<!-- 国情民生特殊处理 end-->
				<!-- ------------------------webchanneltypeid == "30"-------------------------- -->
				<div
					class="special-column"
					style="margin: 0; padding: 0"
					v-if="specialColumnData.children"
				>
					<div class="title_study">
						<a href="#" class="t_txt"
							><img
								src="./images/icon_title.png"
								class="special-column-icon"
							/>
							<span v-if="$route.query.uid != 'A31024'"
								>长期专题</span
							>
							<span v-else>历史专题</span>
							<!-- {{ specialColumnData.text }} -->
						</a>
					</div>
					<div class="t_line">
						<img src="./images/icon_title_line.png" />
					</div>
					<ul class="accordion">
						<li
							v-for="item in specialColumnData.children"
							:key="item.uid"
						>
							<div class="link">
								<span
									v-if="item.children.length > 0"
									@click="
										specialColumnClick30(
											item.uid,
											item.listType,
											true
										)
									"
									class="linktxt"
									>{{ item.text }}
								</span>
								<span
									v-else
									@click="
										specialColumnClick30(
											item.uid,
											item.listType,
											false
										)
									"
									class="linktxt"
									>{{ item.text }}
								</span>
								<span
									class="link_icon"
									v-if="item.children.length"
									@click="showChildList($event, item.uid)"
								>
									<img
										:src="
											require('./images/arrow_right.png')
										"
									/>
								</span>
							</div>
							<div
								v-if="item.children.length"
								style="display: none"
								class="spaceShow"
							>
								<ListColumn
									:columnData="item"
									:columnLevelFilterData="
										columnLevelFilterData
									"
									:loadingArticle="firstEntryList"
								>
								</ListColumn>
							</div>
						</li>
					</ul>
				</div>
				<!-- ------------------------webchanneltypeid == "20"-------------------------- -->
				<div
					class="special-column"
					style="margin: 0; padding: 0"
					v-if="typeIISpecialColumnData.children"
				>
					<div class="title_study">
						<a href="#" class="t_txt"
							><img
								src="./images/icon_title.png"
								class="special-column-icon"
							/>
							<!-- {{ typeIISpecialColumnData.text }} -->
							精选内容
						</a>
					</div>
					<div class="t_line">
						<img src="./images/icon_title_line.png" />
					</div>
					<ul class="accordion">
						<template>
							<li
								v-for="item in typeIISpecialColumnData.children"
								:key="item.uid"
							>
								<div class="link">
									<span
										@click="
											specialColumnClick20(
												item.uid,
												item.listType,
												false
											)
										"
										class="linktxt"
										>{{ item.text }}
									</span>
									<span
										class="link_icon"
										v-if="item.children.length"
										@click="showChildList($event)"
									>
										<img
											:src="
												require('./images/arrow_right.png')
											"
										/>
									</span>
								</div>
								<div
									v-if="item.children.length"
									style="display: none"
								>
									<ListColumn
										:columnData="item"
										:columnLevelFilterData="
											columnLevelFilterData
										"
										:loadingArticle="firstEntryList"
									></ListColumn>
								</div>
							</li>
						</template>
					</ul>
				</div>
				<!-- ------------------------webchanneltypeid == "90"-------------------------- -->
				<template v-if="typeIIISpecialColumnData.length">
					<div
						v-for="(item, index) in typeIIISpecialColumnData[0]
							.children"
						:key="index"
					>
						<router-link
							:to="{
								path: '/list',
								query: {
									uid: item.url.substring(
										10,
										item.url.length
									),
									type: 1,
								},
							}"
						>
							<img
								:src="
									require('./images/' +
										item.url.substring(
											10,
											item.url.length
										) +
										'.jpg')
								"
								border="0"
								:alt="item.text"
							/>
						</router-link>
					</div>
					<!-- <div
            v-for="(item, index) in typeIIISpecialColumnData"
            :key="index"
            style="margin-top: 20px; margin-left: 10px"
          >
            <router-link
              :to="{
                path: '/list',
                query: {
                  uid: item.uid,
                  type: item.listType,
                },
              }"
              >
              <img
                :src="require('./images/' + item.uid + '.jpg')"
                border="0"
                :alt="item.text"
              />
          </router-link>
          </div> -->
				</template>
				<!-- ------------------------      省 份 筛 选       -------------------------- -->
				<!--                      中央政府工作报告 地方政府工作报告                       -->
				<div
					style="margin: 0; padding: 0"
					class="city-filter"
					v-if="
						cityFilterData.length > 0 &&
						windowWidth > 769 &&
						$route.query.uid != 'A304' &&
						$route.query.uid != 'A31049'
					"
				>
					<div
						class="globalbox"
						id="news-column-style"
						v-for="(item, index) in cityFilterData"
						:key="index"
					>
						<template
							v-if="
								$route.query.uid == 'A302' ||
								$route.query.uid == 'A31003'
							"
						>
							<div class="title_study">
								<a href="#" class="t_txt"
									><img
										src="./images/icon_title.png"
										class="special-column-icon"
									/>
									{{ item.name }}
								</a>
							</div>
							<div class="t_line">
								<img src="./images/icon_title_line.png" />
							</div>
							<ul
								v-for="(itemII, indexII) in item.value"
								:key="indexII"
								class="accordion"
							>
								<li>
									<div class="link">
										<span
											@click="
												firstEntryList(
													$route.query.uid,
													1,
													itemII.text
												)
											"
											class="linktxt"
											>{{ itemII.text }}
										</span>
										<span
											class="link_icon"
											v-if="itemII.child.length"
											@click="showChildList($event)"
										>
											<img
												:src="
													require('./images/arrow_right.png')
												"
											/>
										</span>
									</div>
									<div
										v-if="itemII.child.length"
										style="
											display: none;
											background: #fff;
											padding-left: 16px;
										"
									>
										<!-- ------------------------ -->
										<li
											style=""
											v-for="(
												itemIII, indexIII
											) in itemII.child"
											:key="indexIII"
										>
											<div class="link">
												<span
													style="cursor: pointer"
													@click="
														firstEntryList(
															$route.query.uid,
															1,
															`${itemIII.text}`
														)
													"
													class="linktxt"
													>{{ itemIII.text }}
												</span>
											</div>
										</li>
										<!-- ------------------------- -->
									</div>
								</li>
							</ul>
						</template>

						<template v-else>
							<template v-if="$route.query.uid != 'A31024'">
								<a
									v-if="item.name"
									@click="
										provinceFilterClick(
											listData[0].uid,
											1,
											item.value[0].value
										)
									"
									class="btn_gl lbtn"
									:style="{
										'background-color': '#eeeeee',
										color: '#ac0002',
										cursor:
											index == 0 ? 'pointer' : 'default',
									}"
									><img
										src="./images/icon_note.png"
										width="28"
										height="28"
									/>
									{{ item.name }}</a
								>
								<div
									class="report"
									v-if="item.value.length > 3"
								>
									<!-- v-if="
                      $route.query.uid == 'A31001'
                        ? listData[0].uid == 'A3100103'
                          ? true
                          : false
                        : true
                    " -->
									<!-- v-if="$route.query.uid === 'A31001' && listData[0]?.uid === 'A3100103'" -->
									<!-- v-if="
        $route.query.uid == 'A31001'
          ? listData[0].uid == 'A3100103'
            ? true
            : false
          : true
      " -->
									<!-- 2025-5-7出现报错 其他页面左侧地区列表统一出不来，因为这段代码只有在省市领导的情况下才能显示出来，现在改为在领导讲话时page.selectColumn==A3100103时候才显示 -->
									<template
										v-if="
											$route.query.uid == 'A31001'
												? page.selectColumn ==
												  'A3100103'
													? true
													: false
												: true
										"
									>
										<div
											v-for="(
												itemTab, indexTab
											) in item.value"
											style="cursor: pointer"
											:key="indexTab"
										>
											<div class="re">
												<a
													@click="
														provinceFilterClick(
															listData[0].uid,
															1,
															itemTab.value
														)
													"
													class="r_txt"
												>
													{{ itemTab.name }}
												</a>
											</div>
										</div>
									</template>
								</div>
							</template>
						</template>
					</div>
				</div>
				<!-- 栏目中所有不发送请求的结构 -->
				<columnConfig></columnConfig>
				<div class="envelopebox">
					<a
						:href="'mailto:' + columnData.email"
						class="btn_envelope ebtn"
					>
						<img
							src="./images//icon_envelope.png"
							width="32"
							height="28"
						/>编辑信箱</a
					>
				</div>
			</div>
			<!-- 移动端父级栏目 -->
			<div style="position: relative">
				<div
					v-if="windowWidth < 769 && columnData"
					style="
						width: 100%;
						color: white;
						height: 40px;
						font-weight: bolder;
						font-size: 16;
						text-align: center;
						line-height: 40px;
						background-color: rgb(206, 52, 45);
					"
					@click="firstEntryList(columnData.uid, columnData.listType)"
				>
					{{ columnData.text }}
				</div>
				<div
					style="
						height: 30px;
						width: 30px;
						position: absolute;
						top: 8px;
						right: 16px;
						font-size: 12px;
						line-height: 14px;
						font-weight: lighter;
						z-index: 999;
					"
					v-if="columnData.tags"
					@click="showProvinceFilterState = true"
				>
					<van-icon name="filter-o" color="#ffffff" size="25" />
				</div>
			</div>
			<!-- 移动端栏目 -->
			<van-tabs
				v-if="
					windowWidth < 769 &&
					columnData &&
					$route.query.uid != 'A31024'
				"
				@click="onclickMobileNav"
				v-model="mNavSelect"
			>
				<van-tab
					v-for="item in columnData.children"
					v-if="
						item.webchanneltypeid != 30 &&
						item.webchanneltypeid != 90 &&
						item.isnav
					"
					:key="item.uid"
					:title="item.text"
					:name="item.uid"
					:active="null"
				></van-tab>
			</van-tabs>
			<!-- ------------------------     移动端省份筛选       -------------------------- -->
			<van-action-sheet
				v-if="
					cityFilterData.length > 0 &&
					windowWidth < 769 &&
					$route.query.uid != 'A304' &&
					$route.query.uid != 'A31049'
				"
				v-model="showProvinceFilterState"
				:actions="columnData.tags[0].value"
				cancel-text="取消"
				close-on-click-action
				@cancel="onCancel"
				@select="mList"
			/>
			<!-- 列表 -->
			<div class="rightbar">
				<!-- 面包屑 开始-->
				<div class="location" v-if="$route.query.uid != '24963'">
					<p>您当前位置：</p>
					<template v-for="(item, index) in breadCrumbData">
						<span :key="item.uid" style="cursor: pointer">
							<router-link
								class="location"
								v-if="item.uid == 'A3'"
								:to="{ path: '/' }"
								>{{ item.Text }}</router-link
							>
							<span
								v-else
								class="location"
								@click="firstEntryList(item.uid, 1)"
							>
								<span v-if="index != breadCrumbData.length"
									>&gt;</span
								>
								{{ item.Text }}
							</span>
						</span>
					</template>
				</div>
				<div v-else class="location">
					<p>您当前位置：</p>
					<template>
						<span style="cursor: pointer">
							<router-link class="location" :to="{ path: '/' }"
								>首页</router-link
							>
							<span class="location">
								<span>&gt;</span>
								信息精选季刊
							</span>
						</span>
					</template>
				</div>
				<!-- 面包屑 结束-->
				<div class="latelybox">
					<!-- 区域发展 -->
					<div
						class="arealist"
						v-if="
							($route.query.uid == 'A304' &&
								cityFilterForRegionalDevelopment) ||
							($route.query.uid == 'A31049' &&
								cityFilterForRegionalDevelopment)
						"
					>
						<div
							width="97%"
							border="0"
							align="center"
							cellpadding="3"
							cellspacing="2"
							class="regional-development-style"
							v-if="cityFilterData[0]"
						>
							<div
								:class="
									$route.query.uid == 'A304'
										? 'regional-development'
										: 'regional-development-105'
								"
								bgcolor="#EEEEEE"
								v-for="(item, index) in cityFilterData[0].value"
								:key="index"
							>
								<a
									@click="
										firstEntryListClick(
											page.selectColumn,
											1,
											item.value
										)
									"
									class="bl"
									>{{ item.name }}</a
								>
							</div>
						</div>
					</div>
					<!-- 标题列表 -->
					<div
						class="lately_b1"
						v-if="listData.childList && !loadingState"
					>
						<div
							v-for="(itemParent, index) in listData.childList"
							:key="index"
							style="padding: 10px 0"
						>
							<div class="point">
								<p>
									<a class="point_title">{{
										itemParent.text
									}}</a>
									<span
										class="btn_more"
										@click="
											firstEntryList(itemParent.uid, 1)
										"
									>
										<span class="more_txt"
											>更多&gt;&gt;</span
										>
									</span>
								</p>
							</div>
							<div class="lately_b1_list">
								<ul>
									<div
										v-for="(
											itemChild, index
										) in itemParent.docList"
										:key="index"
									>
										<li class="p_title">
											<a
												style="padding: 8px 0px 0px 4px"
												:href="
													$ArticleUrl +
													'?chnid=' +
													itemChild.chnid +
													'&leafid=' +
													itemChild.leafid +
													'&docid=' +
													itemChild.code.substring(
														4,
														itemChild.code.length
													) +
													'&uid=' +
													itemChild.uid +
													'&version=gov'
												"
												:title="itemChild.title"
												target="_blank"
												class="p_titletxt"
												><span
													style="
														color: #ac0002;
														font-weight: bold;
													"
													>·</span
												>{{ itemChild.title }}</a
											><span
												class="p_date"
												style="padding: 8px 0px 0px 6px"
											>
												<span name="deliveddate"
													>&nbsp;{{
														itemChild.deliveddate
													}}</span
												></span
											>
										</li>
										<div class="clear"></div>
									</div>
								</ul>
							</div>
						</div>
					</div>
					<!-- 领导人 更新限制条件 -->
					<NationalLeadership
						v-if="
							page.selectColumn == 'A3100101' &&
							nationalLeadershipShowState
						"
						@leaderName="firstEntryListClick('A3100101', 1, $event)"
					>
					</NationalLeadership>
					<!-- 普通列表 -->
					<ul
						class="leaflist"
						v-if="
							!listData.childList &&
							listData.length &&
							!loadingState
						"
					>
						<li
							class="latelynews"
							v-for="(item, index) in listData[0].docList"
							:key="index"
						>
							<a
								name="subject"
								:href="
									$ArticleUrl +
									'?chnid=' +
									item.chnid +
									'&leafid=' +
									item.leafid +
									'&docid=' +
									item.code.substring(4, item.code.length) +
									'&uid=' +
									item.uid +
									'&version=gov'
								"
								:title="item.title"
								target="_blank"
								class="latelytxt"
								>{{ item.title }}</a
							>
							<span class="news_date">
								<span name="deliveddate"
									>&nbsp;{{ item.deliveddate }}</span
								>
							</span>
						</li>
					</ul>
					<!-- 季刊列表 -->
					<ul
						class="leaflist"
						v-if="listData.data && $route.query.uid == '24963'"
					>
						<li
							class="latelynews"
							v-for="(item, index) in listData.data"
							:key="index"
						>
							<a
								v-if="token"
								name="subject"
								:href="
									$ArticleUrl +
									'?chnid=' +
									item.chnid +
									'&leafid=' +
									item.leafid +
									'&docid=' +
									item.code.substring(4, item.code.length) +
									'&version=edu&downloadflag=down'
								"
								:title="item.title"
								target="_blank"
								class="latelytxt"
								>{{ item.title }}</a
							>
							<span
								v-else
								:title="item.title"
								class="latelytxt"
								@click="logonLabel"
							>
								{{ item.title }}
							</span>
							<span class="news_date">
								<span name="deliveddate"
									>&nbsp;{{
										item.deliveddate.slice(0, 10)
									}}</span
								>
							</span>
						</li>
					</ul>
					<!-- 列表骨架屏 -->
					<template>
						<div
							v-if="loadingState"
							style="width: 100%; margin: 20px"
						>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
						</div>
						<div
							v-if="loadingState"
							style="width: 100%; margin: 20px"
						>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
						</div>
						<div
							v-if="loadingState"
							style="width: 100%; margin: 20px"
						>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
							<div style="margin-bottom: 32px">
								<el-skeleton
									:rows="1"
									animated
									style="
										display: inline-block;
										width: calc(100% - 160px);
									"
								/>
								<el-skeleton
									:rows="1"
									animated
									style="display: inline-block; width: 160px"
								/>
							</div>
						</div>
					</template>
					<!-- 分页 -->
					<div
						class="y-pagination"
						v-if="page.isShow && windowWidth > 769"
					>
						<el-pagination
							layout="total, prev, pager, next, jumper"
							:page-size="page.limit"
							:current-page.sync="page.start"
							:total="page.total"
							@size-change="pageSizeChange"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
					<!-- 移动端分页 -->
					<div
						class="y-pagination"
						style="text-align: center"
						v-if="page.isShow && windowWidth < 769"
					>
						<el-pagination
							small
							layout="prev, pager, next"
							:page-size="page.limit"
							:current-page.sync="page.start"
							:total="page.total"
							@size-change="pageSizeChange"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getArticleList,
	getNav,
	getQuarterly,
	getNPCandCPPCCD,
} from '../../require/api';
import ListColumn from '../../components/ListColumn';
import NPCandCPPCC from './components/NPCandCPPCC/index.vue';
import columnConfig from './components/columnConfig/index.vue';
import NationalLeadership from './components/NationalLeadership/index.vue';
import SubNav from '../../components/SubNav/index.vue';
export default {
	name: 'list',
	components: {
		ListColumn,
		NPCandCPPCC,
		columnConfig,
		NationalLeadership,
		SubNav,
	},
	data() {
		return {
			listData: '',
			columnData: '',
			loadingState: false,
			columnDataRefresh: true,
			columnLevelFilterData: [],
			// 专题
			specialColumnData: {},
			// 二类专题
			typeIISpecialColumnData: {},
			// 三类专题
			typeIIISpecialColumnData: [],
			// token
			token:
				localStorage.getItem('token') != null
					? localStorage.getItem('token')
					: '',
			// 面包屑：暂定下发
			breadCrumbData: [], //<?--------------------------
			// 分页
			page: {
				start: 1,
				limit: 20,
				total: 0,
				selectColumn: '',
				type: '',
				isShow: false,
				attr: '',
			},
			// 城市过滤
			cityFilterData: [],
			// 移动端导航
			mNavSelect: null,
			// 移动端省份选择框展示状态
			showProvinceFilterState: false,
			// 领导人显示状态
			nationalLeadershipShowState: false,
			// pageShow
			pageShow: false,
			// 区域发展->省份筛选显示状态
			cityFilterForRegionalDevelopment: true,
			// 文字选中状态
			selectedState: '#333',
		};
	},
	created() {
		// 首次进入读取文章列表与分页数据
		// if (this.$route.query.type == 1) {
		//   this.firstEntryList(this.$route.query.uid, this.$route.query.type);
		// }
		if (!this.$route.query.chnid) {
			// if (this.$route.query.uid == "24963") {
			//   // this.firstEntryList();
			// }
			this.getColumnData();
		}
		if (
			this.$route.query.uid == 'A31021' ||
			this.$route.query.uid == 'A31022' ||
			this.$route.query.uid == 'A31030' ||
			this.$route.query.uid == 'A31023' ||
			this.$route.query.uid == 'A31019'
		) {
			this.provinceFilter(this.$route.query.uid, 1);
			this.page.isShow = true;
		} else if (this.$route.query.childUid) {
			this.firstEntryList(
				this.$route.query.childUid,
				this.$route.query.type
			);
		} else {
			// console.log(this.$route.query.uid, this.$route.query.type);

			this.firstEntryList(this.$route.query.uid, this.$route.query.type);
		}
	},
	methods: {
		// 首次进入列表页面 获取栏目
		async getColumnData() {
			const {
				data: { data },
			} = await getNav({ uid: this.$route.query.uid });
			if (data.code == 0) {
				this.columnData = data.data;
				for (let i = 0; i < this.columnData.children.length; i++) {
					const element = this.columnData.children[i];
					if (element.webchanneltypeid == '30') {
						this.specialColumnData = element;
					} else if (element.webchanneltypeid == '20') {
						this.typeIISpecialColumnData = element;
					} else if (element.webchanneltypeid == '90') {
						this.typeIIISpecialColumnData.push(element);
					}
				}
				this.checkColumnHasRouterUid(this.columnData);
				this.columnData;
				this.cityFilterData = [];
				if (this.columnData.tags && this.columnData.tags.length) {
					// // 处理数据并存储为长度为三的数组保存在cityFilterData中
					// for (let i = 0; i < this.columnData.tags.value.length; i += 3) {
					//   this.cityFilterData.push(
					//     this.columnData.tags[0].value.slice(i, i + 3)
					//   );
					// }

					this.cityFilterData = this.columnData.tags;
				}
			}
		},
		// 面包屑
		async getBreadCrumbData(id) {
			const {
				data: { data },
			} = await getNav({ uid: id });
			if (data.code == 0) {
				this.breadCrumbData = data.data.locations;
			}
		},
		// 递归查询是够含有某属性值
		checkColumnHasRouterUid(data) {
			let dataArray = [];
			let level = 0;
			if (Array.isArray(data)) {
				this.test = this.getAndSetLevel(data, level, 3);
			} else {
				dataArray.push(data);
				this.test = this.getAndSetLevel(dataArray, level, 3);
			}
			// if (data instanceof Array) {
			//   // console.log("data", data);
			//   let level = 0;
			//   this.test = this.getAndSetLevel(data, level);
			// } else {
			//   dataArray.push(data);
			//   this.recursionCheckColumnHasRouterUid(dataArray);
			// }
		},
		// 获取层级数据
		getAndSetLevel(data, level, setLevel) {
			for (let i = 0; i < data.length; i++) {
				const element = data[i];
				if (element.children && element.children.length > 0) {
					level++;
					if (level == setLevel) {
						this.test = element.children;
						// return element.children;
					}
					this.getAndSetLevel(element.children, level);
				}
			}
			return this.test;
		},
		// 首次进入列表页面 获取列表
		firstEntryListClick(selectColumn, type, attr) {
			this.page.selectColumn = selectColumn;
			this.page.type = type;
			this.page.attr = attr;
			this.page.start = 1;

			if (selectColumn == 'A3100101') {
				this.nationalLeadershipShowState = true;
			} else if (
				selectColumn == 'A3100102' ||
				selectColumn == 'A3100103'
			) {
				this.nationalLeadershipShowState = false;
			}
		},
		async firstEntryList(selectColumn, type, attr) {
			this.page.start = 1;
			if (!attr) {
				this.page.attr = '';
			}
			this.textColor = '#333';
			this.textColor = this.textColor === '#333' ? '#ac0002' : '#333';
			// console.log(type);
			// 区域发展-》省份过滤显示
			this.cityFilterForRegionalDevelopment = true;
			// type == 0 为显示标题栏目
			if (type == 0) {
				this.page.isShow = false;
			} else {
				this.page.isShow = true;
			}
			// 返回顶部
			window.scrollTo(0, 0);
			if (selectColumn && selectColumn != 'A310240302') {
				this.getBreadCrumbData(selectColumn);
			} else {
				this.getBreadCrumbData(this.$route.query.uid);
			}
			// this.getBreadCrumbData(selectColumn)
			// 判断条件2：是否本页面传递参数
			this.page.type = type;
			if (selectColumn && attr) {
				this.page.selectColumn = selectColumn;
				this.page.attr = attr;
				const param = {
					uid: selectColumn,
					curpage: this.page.start,
					pagesize: type == 0 ? 10 : 20,
					isdefault: type == 0 ? true : false,
					webChannelTypeId: '1',
					attr: attr, //省份过滤
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (type == '1') {
						this.page.total = data.data[0].totlalCount;
					}
				}
			} else if (selectColumn && this.$route.query.uid != '24963') {
				this.page.selectColumn = selectColumn;
				const param = {
					uid: selectColumn,
					curpage: this.page.start,
					pagesize: type == 0 ? 10 : 20,
					isdefault: type == 0 ? true : false,
					webChannelTypeId: '1',
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					// console.log('this.listData',this.listData);
					if (type == '1') {
						// console.log("data.data[0]",data.data[0].totlalCount)
						this.page.total = data.data[0].totlalCount;
					}
				}
			}
			// 判断条件1：是否通过query传输 排除特殊跳转：季刊
			else if (
				this.$route.query.uid != '24963' &&
				this.$route.query.uid != 'A31022' &&
				this.$route.query.uid != 'A31021'
			) {
				const param = {
					uid: this.$route.query.uid,
					curpage: '1',
					pagesize: this.$route.query.type == 0 ? 10 : 20,
					isdefault: this.$route.query.type == 0 ? true : false,
					webChannelTypeId: '1',
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
				}
			}
			// 判断条件3：首页季刊跳转到列表页
			else if (this.$route.query.uid == '24963') {
				this.loadingState = true;
				const {
					data: { data },
				} = await getQuarterly({
					leafId: this.$route.query.uid,
					curpage: 1,
					pagesize: 20,
				});
				if (data.code == 0) {
					this.listData = data.data;
					this.loadingState = false;
				}
			}

			// 筛选条加4：列表领导人显示
			// 显示领导人
			if (selectColumn == 'A3100101') {
				this.nationalLeadershipShowState = true;
			} else if (
				selectColumn == 'A3100102' ||
				selectColumn == 'A3100103'
			) {
				this.nationalLeadershipShowState = false;
			}

			LogCollection.send(0);
		},
		async firstEntryListForPage(selectColumn, type, attr) {
			if (!attr) {
				this.page.attr = '';
			}
			this.textColor = '#333';
			this.textColor = this.textColor === '#333' ? '#ac0002' : '#333';
			// console.log(type);
			// 区域发展-》省份过滤显示
			this.cityFilterForRegionalDevelopment = true;
			// type == 0 为显示标题栏目
			if (type == 0) {
				this.page.isShow = false;
			} else {
				this.page.isShow = true;
			}
			// 返回顶部
			window.scrollTo(0, 0);
			if (selectColumn && selectColumn != 'A310240302') {
				this.getBreadCrumbData(selectColumn);
			} else {
				this.getBreadCrumbData(this.$route.query.uid);
			}
			// this.getBreadCrumbData(selectColumn)
			// 判断条件2：是否本页面传递参数
			this.page.type = type;
			if (selectColumn && attr) {
				this.page.selectColumn = selectColumn;
				this.page.attr = attr;
				const param = {
					uid: selectColumn,
					curpage: this.page.start,
					pagesize: type == 0 ? 10 : 20,
					isdefault: type == 0 ? true : false,
					webChannelTypeId: '1',
					attr: attr, //省份过滤
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (type == '1') {
						this.page.total = data.data[0].totlalCount;
					}
				}
			} else if (selectColumn && this.$route.query.uid != '24963') {
				this.page.selectColumn = selectColumn;
				const param = {
					uid: selectColumn,
					curpage: this.page.start,
					pagesize: type == 0 ? 10 : 20,
					isdefault: type == 0 ? true : false,
					webChannelTypeId: '1',
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (type == '1') {
						this.page.total = data.data[0].totlalCount;
					}
				}
			}
			// 判断条件1：是否通过query传输 排除特殊跳转：季刊
			else if (
				this.$route.query.uid != '24963' &&
				this.$route.query.uid != 'A31022' &&
				this.$route.query.uid != 'A31021'
			) {
				const param = {
					uid: this.$route.query.uid,
					curpage: '1',
					pagesize: this.$route.query.type == 0 ? 10 : 20,
					isdefault: this.$route.query.type == 0 ? true : false,
					webChannelTypeId: '1',
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
				}
			}
			// 判断条件3：首页季刊跳转到列表页
			else if (this.$route.query.uid == '24963') {
				this.loadingState = true;
				const {
					data: { data },
				} = await getQuarterly({
					leafId: this.$route.query.uid,
					curpage: 1,
					pagesize: 20,
				});
				if (data.code == 0) {
					this.listData = data.data;
					this.loadingState = false;
				}
			}

			// 筛选条加4：列表领导人显示
			// 显示领导人
			if (selectColumn == 'A3100101') {
				this.nationalLeadershipShowState = true;
			} else if (
				selectColumn == 'A3100102' ||
				selectColumn == 'A3100103'
			) {
				this.nationalLeadershipShowState = false;
			}
			LogCollection.send(0);
		},
		// 展示子栏目
		showChildList(item, id) {
			const elementContent =
				item.currentTarget.parentElement.nextElementSibling;
			const eventElement = item.currentTarget.firstElementChild;
			// value为零不展示
			if (elementContent.style.display == 'block') {
				eventElement.src = require('./images/arrow_right.png');
				elementContent.style.display = 'none';
			} else {
				eventElement.src = require('./images/arrow_bottom.png');
				elementContent.style.display = 'block';
			}
			// if (id == "A310240302") {
			//   eventElement.src = require("./images/arrow_bottom.png");
			//   elementContent.style.display = "block";
			// }else{
			//   eventElement.src = require("./images/arrow_right.png");
			//   elementContent.style.display = "none";
			// }
		},
		// “暂无权限-需要登录”
		logonLabel() {
			alert('“暂无权限-需要登录”');
		},
		// 分页
		pageSizeChange(size) {
			this.page.limit = size;
			if (this.page.attr) {
				if (
					this.$route.query.uid == 'A31021' ||
					this.$route.query.uid == 'A31022' ||
					this.$route.query.uid == 'A31030' ||
					this.$route.query.uid == 'A31023' ||
					this.$route.query.uid == 'A31019' ||
					(this.$route.query.uid == 'A31001' &&
						this.listData[0].uid == 'A3100103')
				) {
					this.provinceFilter(
						this.page.selectColumn,
						1,
						this.page.attr
					);
				} else {
					this.firstEntryList(
						this.page.selectColumn,
						this.page.type,
						this.page.attr
					);
				}
			} else {
				this.firstEntryListForPage(
					this.page.selectColumn,
					this.page.type
				);
			}
		},
		pageChange(cPage) {
			this.page.start = cPage;
			if (this.page.attr) {
				if (
					this.$route.query.uid == 'A31021' ||
					this.$route.query.uid == 'A31022' ||
					this.$route.query.uid == 'A31030' ||
					this.$route.query.uid == 'A31023' ||
					this.$route.query.uid == 'A31019' ||
					(this.$route.query.uid == 'A31001' &&
						this.listData[0].uid == 'A3100103')
				) {
					this.provinceFilter(
						this.page.selectColumn,
						1,
						this.page.attr
					);
				} else {
					this.firstEntryListForPage(
						this.page.selectColumn,
						this.page.type,
						this.page.attr
					);
				}
			} else {
				this.firstEntryListForPage(
					this.page.selectColumn,
					this.page.type
				);
			}
		},
		// 移动端导航点击事件
		onclickMobileNav(name) {
			if (this.windowWidth < 769) {
				this.firstEntryList(name, 1);
			}
		},
		// 移动端省份过滤：关闭弹窗
		onCancel() {
			Toast('取消');
		},
		async mList(item) {
			const param = {
				uid: this.$route.query.uid,
				curpage: this.page.start,
				pagesize: 20,
				isdefault: false,
				webChannelTypeId: '1',
				attr: item.value, //省份过滤
			};
			this.loadingState = true;
			const { data: data } = await getArticleList(param);
			LogCollection.send(0);
			if (data.code == '0') {
				this.listData = data.data;
				this.page.total = data.data[0].totlalCount;
				this.page.type = '1';
				this.loadingState = false;
			}
		},
		// 条件为30的数据
		async specialColumnClick30(id, type, child) {
			this.page.start = 1;
			this.cityFilterForRegionalDevelopment = false;
			this.page.selectColumn = id;
			type == 0 ? (this.page.isShow = false) : true;

			if (id) {
				const param = {
					uid: id,
					curpage: this.page.start,
					pagesize: child ? 10 : 20,
					isdefault: child,
					webChannelTypeId: 30,
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (child == false) {
						this.page.isShow = true;
						this.page.total = data.data[0].totlalCount;
					}
				}
			}
			this.getBreadCrumbData(id);
			LogCollection.send(0);
		},
		// 条件为20的数据
		async specialColumnClick20(id, type, child) {
			this.page.start = 1;
			this.cityFilterForRegionalDevelopment = false;
			this.page.selectColumn = id;
			if (id) {
				const param = {
					uid: id,
					curpage: this.page.start,
					pagesize: 20,
					isdefault: child,
					webChannelTypeId: 20,
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (child == false) {
						this.page.isShow = true;
						this.page.total = data.data[0].totlalCount;
					}
				}
			}
			this.getBreadCrumbData(id);
			LogCollection.send(0);
		},
		// 条件为90的数据
		async specialColumnClick90(id, type, child) {
			this.page.start = 1;
			this.cityFilterForRegionalDevelopment = false;
			this.page.selectColumn = id;
			if (id) {
				const param = {
					uid: id,
					curpage: this.page.start,
					pagesize: child,
					isdefault: child,
					webChannelTypeId: 90,
					attr: attr,
				};
				this.loadingState = true;
				const { data: data } = await getArticleList(param);
				if (data.code == '0') {
					this.listData = data.data;
					this.loadingState = false;
					if (child == false) {
						this.page.isShow = true;
						this.page.total = data.data[0].totlalCount;
					}
				}
			}
			this.page.attr = '';
			LogCollection.send(0);
		},
		// 省份筛选
		async provinceFilter(selectColumn, type, attr) {
			this.page.selectColumn = selectColumn;
			this.page.type = +type;
			this.page.attr = attr;
			// 判断条件5：无栏目列表
			// if (
			//   this.$route.query.uid == "A31021" ||
			//   this.$route.query.uid == "A31022" ||
			//   this.$route.query.uid == "A31030" ||
			//   this.$route.query.uid == "A31023" ||
			//   this.$route.query.uid == "A31019" ||
			//   (this.$route.query.uid == "A31001" &&
			//     this.listData[0].uid == "A3100103")
			// ) {
			this.loadingState = true;
			var param = {
				uid:
					this.$route.query.uid == 'A31001'
						? this.listData[0].uid == 'A3100103'
							? 'A3100103'
							: ''
						: this.$route.query.uid,
				//   uid:
				// this.$route.query.uid == "A31001"
				//   ? this.listData[0].uid == "A3100103"
				//     ? "A3100103"
				//     : ""
				//   : selectColumn,
				curpage: this.page.start,
				pagesize: 20,
				isdefault: false,
				webChannelTypeId: '1',
				attr: attr,
			};
			const { data: data } = await getArticleList(param);
			if (data.code == '0') {
				this.listData = data.data;
				this.page.total = data.data[0].totlalCount;
				this.loadingState = false;
			}
			// }
			if (this.$route.query.uid == 'A31024') {
				this.breadCrumbData = [
					{ Text: '首页', uid: 'A3' },
					{ Text: '国情民生', uid: 'A31024' },
				];
			}
			LogCollection.send(0);
		},
		// 点击筛选
		provinceFilterClick(selectColumn, type, attr) {
			console.log(selectColumn);
			this.page.selectColumn = selectColumn;
			this.page.type = +type;
			this.page.attr = attr;
			LogCollection.send(0);
		},
		// 文字搜索专题
		wordSearchArticleLIst() {
			// this.wordSearchArticleData = this.
		},
		initPage() {
			this.page.start = 1;
			this.page.total = 0;
		},
	},
	mounted() {
		this.onclickMobileNav();
	},
	watch: {
		$route(to, from) {
			this.specialColumnData = {};
			this.typeIISpecialColumnData = {};
			this.typeIIISpecialColumnData = [];
			this.firstEntryList(this.$route.query.uid, this.$route.query.type);
			this.nationalLeadershipShowState = false;
			this.getColumnData();
			this.page.attr = '';
		},
		'page.selectColumn': function () {
			this.initPage();
		},
		'page.attr': function (newValue) {
			this.initPage();
			//  this.pageChange(1)
			// this.pageChange(1);
			if (newValue != '') {
				this.loadingState = true;
				if (this.page.selectColumn != 'A3100101') {
					this.provinceFilter(this.page.selectColumn, 1, newValue);
					this.page.isShow = true;
					this.loadingState = false;
				} else {
					this.firstEntryList('A3100101', 1, newValue);
					this.page.isShow = true;
					this.loadingState = false;
				}
			}
		},
	},
};
</script>

<style lang="less" scoped>
.container {
	width: 1101px;
	margin: 0 auto;
	overflow: hidden;

	.leftbar {
		float: left;
		width: 248px;
		background-color: #f8f8f8;
		margin-top: 16px;

		.viewbox {
			width: 248px;
			margin-top: 8px;

			.view {
				height: 44px;
				color: #fff;
				font-family: '微软雅黑';
				font-size: 18px;
				font-weight: bold;
				line-height: 44px;
				background-color: #ac0002;
				padding: 0 0 0 30px;
			}

			.accordion {
				li {
					.link {
						background: url(./images/icon_red_shidian.png) no-repeat
							left;
						padding: 0px 0px 0px 30px;
						border-bottom: 1px dotted #d5d5d5;
						position: relative;
						cursor: pointer;

						.linktxt {
							color: #333;
							font-family: '微软雅黑';
							font-size: 15px;
							font-weight: bold;
							line-height: 40px;
							vertical-align: middle;
						}

						.link_icon {
							/* padding-left: 70px; */
							position: absolute;
							right: 18px;
							bottom: 11px;
						}
					}
				}
			}
		}

		.special-column {
			.title_study {
				padding: 42px 0 0 8px;

				.t_txt {
					font-family: '微软雅黑';
					font-weight: bold;
					font-size: 18px;
					color: #c10103;
					vertical-align: middle;

					.special-column-icon {
						height: 18px;
						vertical-align: middle;
						margin-right: 4px;
					}
				}
			}

			.t_line {
				padding: 0 0 10px 0;
			}

			.accordion {
				li {
					.link {
						&::before {
							content: '◆';
							position: absolute;
							left: 11px;
							top: 11px;
							font-size: 20px;
						}

						padding: 0px 0px 0px 30px;
						border-bottom: 1px dotted #d5d5d5;
						position: relative;

						.linktxt {
							color: #333;
							font-family: '微软雅黑';
							font-size: 15px;
							line-height: 40px;
							vertical-align: middle;
						}

						.link_icon {
							/* padding-left: 70px; */
							position: absolute;
							right: 18px;
							bottom: 11px;
						}
					}
				}
			}
		}

		.envelopebox {
			width: 230px;
			margin: 0 auto;
			padding: 30px 0 30px 0;

			.btn_envelope {
				width: 190px;
				height: 42px;
				color: #333333;
				font-family: '微软雅黑';
				line-height: 42px;
				padding-left: 40px;
			}

			a {
				display: block;
				background-color: #e4e5e6;
				border-radius: 8px;

				img {
					position: relative;
					top: 1px;
					margin-right: 10px;
				}
			}
		}

		.city-filter {
			.globalbox {
				margin: 0 auto;

				// padding: 40px 0 20px 0;
				a {
					display: block;

					img {
						position: relative;
						top: 6px;
						margin-right: 8px;
					}
				}

				.btn_gl {
					width: 243px;
					height: 42px;
					color: #fff;
					font-family: '微软雅黑';
					line-height: 42px;
					padding-left: 5px;
				}

				.lbtn {
					margin-top: 8px;
				}
			}

			.report {
				margin: 0 auto;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;

				.re {
					padding: 4px 0;
					width: 66px;

					.r_txt {
						color: #333333;
						font-size: 14px;
						font-family: '微软雅黑';
						text-align: center;
						display: block;
						/* padding: 0px 12px; */
					}
				}

				.rw {
					padding: 0px 0px 0px 30px;
					border-bottom: 1px dotted #d5d5d5;
					position: relative;
					width: 248px;

					&::before {
						content: '◆';
						position: absolute;
						left: 11px;
						top: 11px;
						font-size: 20px;
					}

					// .r_txt {
					//   color: #333333;
					//   font-size: 14px;
					//   font-family: "微软雅黑";
					//   display: block;
					//   /* padding: 0px 12px; */
					// }
				}
			}
		}
	}

	.rightbar {
		float: right;

		.location {
			padding: 44px 0 14px 0;
			color: #333333;
			font-size: 14px;
			font-family: '宋体';

			p {
				color: #333333;
				font-size: 14px;
				font-family: '宋体';
				display: inline-block;
			}
		}

		.latelybox {
			border: 1px solid #ececec;
			width: 811px;
			overflow: hidden;
			padding-bottom: 20px;

			.leaflist {
				margin: 15px;

				.latelynews {
					background: url(./images/icon_li_dot.png) no-repeat left;
					padding: 5px 0 5px 10px;
					margin-top: 8px;

					&:nth-child(10) {
						padding-bottom: 15px;
						border-bottom: 1px dashed #999;
					}

					&:nth-child(11) {
						margin-top: 10px;
					}

					.latelytxt {
						font-family: '宋体';
						font-size: 14px;
						color: #000;
						display: inline-block;
						width: calc(100% - 90px);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						line-height: 120%;
					}

					.news_date {
						font-family: '宋体';
						font-size: 14px;
						color: #000;
						float: right;
					}
				}
			}

			.lately_b1 {
				width: 754px;
				margin: 0 auto;
				padding: 10px 0;

				.point {
					border-bottom: 1px solid #ac0002;
					padding: 0 0 4px 0;
					overflow: hidden;
					position: relative;

					p {
						.point_title {
							color: #ac0002;
							font-size: 15px;
							font-weight: bold;
							font-family: '微软雅黑';
						}

						.btn_more {
							display: block;

							.more_txt {
								font-family: '微软雅黑';
								font-size: 12px;
								color: #666666;
								font-weight: normal;
								position: absolute;
								top: 2px;
								right: 0;
							}
						}
					}
				}

				.lately_b1_list {
					ul {
						li {
							line-height: 110%;
						}

						.p_title {
							.p_titletxt {
								width: calc(100% - 105px);
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								-o-text-overflow: ellipsis;
								float: left;
								padding: 14px 0 10px 12px;
								font-family: '宋体';
								font-size: 14px;
								color: #333333;
							}
						}

						.p_date {
							float: right;
							cursor: pointer;
							font-family: '宋体';
							font-size: 14px;
							color: #333333;
						}

						.clear {
							clear: both;
						}
					}
				}
			}
		}
	}

	.submenu3 {
		li {
			padding: 6px 0 6px 36px;
			border-top: 1px dashed #d5d5d5;
			background-color: #fff;
			cursor: pointer;
		}
	}

	.classfy3 {
		color: #535353;
		font-size: 13px;
		font-family: '微软雅黑';
		font-size: 14px;
	}

	.arealist {
		margin: 30px 10px 30px 30px;

		.regional-development-style {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: flex-start;

			.regional-development {
				display: inline-block;
				// width: 75px;
				width: 79px;
				height: 28px;
				text-align: center;
				background: #eeeeee;
				margin: 0 4px 4px 0;
				cursor: pointer;

				&:hover {
					background-color: #2b86e2;

					.bl {
						color: #fff !important;
					}
				}

				.bl {
					color: #565454;
					font-family: '宋体';
					font-size: 12px;
					color: #565454;
					line-height: 28px;
					cursor: pointer;
				}
			}
			.regional-development-105 {
				display: inline-block;
				width: 105px;
				height: 28px;
				text-align: center;
				background: #eeeeee;
				margin: 0 4px 4px 0;
				cursor: pointer;

				&:hover {
					background-color: #2b86e2;

					.bl {
						color: #fff !important;
					}
				}

				.bl {
					color: #565454;
					font-family: '宋体';
					font-size: 12px;
					color: #565454;
					line-height: 28px;
					cursor: pointer;
				}
			}
		}
	}

	#news-column-style {
		margin-top: 40px;

		.title_study {
			a {
				font-family: '微软雅黑';
				font-weight: bold;
				font-size: 18px;
				color: #c10103 !important;
				vertical-align: middle;
			}
		}

		.accordion {
			.link {
				position: relative;
				border-bottom: dashed 1px #d5d5d5;

				.linktxt {
					color: #000;
					font-size: 15px;
					font-family: '微软雅黑';
					line-height: 35px;
					padding: 0 0 0 10px;
				}
			}

			.link_icon {
				cursor: pointer;
				position: absolute;
				right: 18px;
				bottom: 11px;
			}
		}
	}

	.linktxt,
	.point_title,
	.more_txt,
	.link_icon,
	.classfy {
		cursor: pointer;
	}

	.overflow {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

@media screen and (max-width: 769px) {
	.container {
		width: 100%;

		.rightbar {
			float: none !important;
			padding: 0 16px;

			.latelybox {
				width: 100% !important;
				padding: 0 8px;

				.lately_b1 {
					width: 100%;
				}
			}

			.location {
				padding: 20px 0 14px 0 !important;
			}
		}
	}

	.content-province-pop {
		width: 80px;
		text-align: center;
		font-size: 12px;
		padding: 6px 0;
		float: left;
		margin: 0 8px 16px 8px;
		border: 1px solid #409eff;
		border-radius: 20px;
		//   border: solid; /* 默认情况下，所有四条边都会显示 */
		//  border-color: #409eff; /* 按顺序设置上右下左四条边的颜色（从上到下）*/
		//  border-style: double dashed dotted none; /* 按顺序设置上右下左四条边的样式（从上到下）*/
		//  border-width: 1px 1px 1px 1px; /* 按顺序设置上右下左四条边的宽度（从上到下）*/
	}

	.content-province-pop-style {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
	}
}
</style>
